import IcdCode from "../../models/codes/IcdCode";
import { AssessmentInfo } from "./assessmentInfo";

export default class Diagnosis {
  id: number;
  patientChartId: number;
  icdCode: IcdCode;
  diagnosisType: string;
  startDate: any;
  endDate: any;
  physician: string;
  physicianId: number;
  updatedBy: string;
  sortKey?: number;
  assessmentInfo?: AssessmentInfo;
  active?: boolean;
  diagnosisStatus?: string;
  comment: string;
  constructor() {}
}

export enum DiagnosisStatus {
  IN_PROGRESS = "IN_PROGRESS",
  ACTIVE = "ACTIVE",
  RESOLVED_IN_PROGRESS = "RESOLVED_IN_PROGRESS",
  RESOLVED = "RESOLVED",
}

export const PALLIATIVE_ENCOUNTER_DIAGNOSIS_CODE = "Z515";



// WEBPACK FOOTER //
// ./src/models/patient-chart/diagnosis.ts